import { ErrorsState, ShowErrorUpdateMessageAction } from "./type";

export function showErrorPopupHandler(state: ErrorsState): ErrorsState {
    return Object.assign({}, state, { showErrorPopup: false});
}

export function showErrorUpdateMessageStateHandler(state: ErrorsState, action: ShowErrorUpdateMessageAction): ErrorsState {
    return Object.assign({}, state, {
        showErrorPopup: action.payload.show,
        currentErrorCode: action.payload.errorCode,
        returnToMainScreen: action.payload.returnToMainScreen
    });
}


// WEBPACK FOOTER //
// ./src/store/Errors/handlers.ts